<template lang="pug">
  button.action-button.xs-f-small.lg-f-medium.max-at-tweak(@click="$emit('action-btn-click')")
    .title.upper.color-mr-purple.bold {{ title }}
    .description.color-slate {{ descr }}

</template>

<script>
  export default {
    name: 'ActionButton',
    props: {
      title: {
        type: String,
        required: true
      },

      descr: {
        type: String,
        required: true
      }
    }
  };
</script>

<style scoped lang="stylus">
  .action-button
    border 1px solid color-fog-light
    border-radius 8px
    text-align left
    padding 1.2em 1em 1.3em
    background transparent
    transition 0.2s ease-in-out

    &:hover
      background-color color-fog-light

</style>
